define([
	"jquery",
	"domReady",
	"wcs.find-in-store-model",
	"wcs.find-in-store-render",
	"wcs.find-in-store-util",
	"pubsub",
	"shared.main.screen",
	"shared.main.plugins",
	"wcs.form-validate",
	"foundation.util.keyboard"
], function($, domReady, findInStoreModel, findInStoreRender, findInStoreUtil, pubsub, screenSize, pluginLoader, formValidate){
	var DEBUG = false;
	var $document = $(document),
		$searchInput,
        $findInStoreModal,
		$findInStoreContainer,
		$searchForm,
		$searchStoresButton,
		$useMyLocationButton,
		$findStoreButton,
		$addToCartButton,
		isOneSizeProduct = false,
		isPreSelectedProduct = false,
		isROBISEnabled = WCS_CONFIG.get('PDP::ROBISEnabled'),
		isPopupEnabled = true,
		isAllAttributeSelected = false,
		isFindInStoreAltDisplay,
		context = {};

	domReady( function () {
		initialize();
		globalEvents();
	});

	function globalEvents() {
		// increasing the radius to the last option in the drop down.
		$.pubsub('subscribe', 'NO_STORES_WITHIN_RADIUS', function(){
			if( $('.ship-to-store-radius-js').val() !== $('.ship-to-store-radius-js option:last').val()){
				findInStoreModel.resubmitWithMaxRadius();
			}
		});

		// Make sure we only subscribe to this event for non alt display FIS
		if(!isFindInStoreAltDisplay) {
			$.pubsub('subscribe', 'WCS.PRODUCTFORM.ATTRIBUTE.CHANGE.COMPLETE', function(msg, data) {
				if (msg === 'WCS.PRODUCTFORM.ATTRIBUTE.CHANGE.COMPLETE') {
					enableFindInStore();
				}
			});
		}

		$.pubsub('subscribe', 'WCS.PRODUCTFORM.ATTRIBUTE.CHANGE.COMPLETE.SIZEDESELECTED', function() {
			if(DEBUG) console.log('WCS.PRODUCTFORM.ATTRIBUTE.CHANGE.COMPLETE.SIZEDESELECTED');
			disableFindInStore();
		});

		$.pubsub('subscribe','find-in-store.templated-rendered', function() {
			Foundation.Keyboard.releaseFocus($findInStoreModal);
			Foundation.Keyboard.trapFocus($findInStoreModal);
		});

		$.pubsub('subscribe', 'WCS.PRODUCTFORM.COLORWAY_PRODUCT.FORM_UPDATE', function(msg, data) {
			initialize();
		});
	}

	function initialize() {
		$searchInput = $(".in-store-availability-search-input-js");
		$findInStoreModal = $('#find-in-store-modal');
		$findInStoreContainer = $(".find-store-container-js");
		$searchForm = $('.in-store-availability-search-autocomplete-form-js');
		$searchStoresButton = $("#search-stores");
		$useMyLocationButton = $(".use-my-location-button-js");
		$findStoreButton = $('.find-store-js');
		isFindInStoreAltDisplay = $findStoreButton.data('findInStoreAltDisplay');
		isOneSizeProduct = $('.attr-size .attr-box-js').length === 1;
		$addToCartButton = $('.add-to-bag-js');

		findInStoreUtil.hideRetailStoreInfo();
		attachHandlers();
		// Method to check OSFA scenario since isOneSizeProduct is only used when isFindInStoreAltDisplay is true (TNF-only)
		checkForOneSizeProduct();

		if(isFindInStoreAltDisplay) {
			findInStoreAltDisplayHandlers();
			renderFindInStoreAltDisplay();
		}

		if (isROBISEnabled) {
			initROBIS();
		}
	}

	// On load loop through available size options to check if product fits in the OSFA scenario
	function checkForOneSizeProduct() {
		var $sizeDropdown = $('.attr-input-js'),
				$options = $sizeDropdown.find('option'),
				totalOptions = [];

		$options.each(function(index, option) {
			var validOption = $(option).data('attribute-value');
			if (validOption) {
				totalOptions.push(validOption);
			}
		});

		if (totalOptions.length === 1) {
			enableFindInStore();
		}
	}

	function _triggerfindInStoreButtonClickOnCookie(){
		var zipCookie = findInStoreUtil.getZipCookie("USER_ENTERED_ZIP");
	    $('.find-a-store-form-js form input[name="shipToStoreZip"]').val(zipCookie);
	    if(DEBUG) console.log('retrived USER_ENTERED_ZIP value', zipCookie);
	    $("#search-stores").trigger('click');
	}

	function _moveFindInStoreContainerToModal(){
		if( $('.find-in-store-modal').length && $findInStoreContainer.length ){
			$('.find-in-store-modal-container-js').append($findInStoreContainer.removeClass('hide'));
		}
	}
	//================== INLINE FIND IN STORE CONTAINER ==================
	// For inline find in store instead of reveal modal
	function _showFindInStoreContainerInline() {
		var $findInStoreInlineContainer = $('.find-in-store-container.in-line');
		if($findInStoreInlineContainer.length > 0){
			$('.store-results-list').empty();
			$findInStoreInlineContainer.append($findInStoreContainer.removeClass('hide'));
			findInStoreUtil.openFindInStoreContainer($findInStoreInlineContainer);
		}
	}

	//================== END INLINE FIND IN STORE CONTAINER ==================

	function attachHandlers(){
		$document.on('open.zf.reveal', '#find-in-store-modal[data-reveal]', function() {
			_moveFindInStoreContainerToModal();

			if (!isROBISEnabled && findInStoreUtil.getZipCookie("USER_ENTERED_ZIP") !== undefined ){
				_triggerfindInStoreButtonClickOnCookie();
			}
			var isSplitSizeEnabled = findInStoreUtil.getIsSplitSizedEnabled();
			if (isROBISEnabled && !isSplitSizeEnabled) {
				findInStoreUtil.resetROBIS();

				var size = findInStoreUtil.getSelectedSize();

				if (size === null) {
					findInStoreUtil.setSizeNotSelectedView();
				} else {
					findInStoreUtil.updateActiveSize(size);
					findInStoreUtil.setSizeSelectedView();
				}
			} else if (isROBISEnabled && isSplitSizeEnabled){
				findInStoreUtil.resetROBIS();

				var selections = findInStoreUtil.getSelectedSplitSize();
				if (selections.size && selections.width) {
					var catEntryId = findInStoreUtil.getSplitSizeCatEntryId(selections.size, selections.width);
					findInStoreUtil.updateActiveSize(selections.size, catEntryId, selections.width);
					findInStoreUtil.setSizeSelectedView();
				} else {
					findInStoreUtil.setSizeNotSelectedView();
				}
			}
			// Re-trap focus because new content is added to modal
			Foundation.Keyboard.releaseFocus($findInStoreModal);
			Foundation.Keyboard.trapFocus($findInStoreModal);
		});

		$findStoreButton.on('click', function() {
			if(shouldOpenPopUp()){
				findInStoreUtil.openPopup();
			}
		});

		$document.on('click', '.find-in-store-inline-link-js:not(.disabled)', function(event) {
			if ($('.find-in-store-container.in-line:hidden').length > 0) {
				_showFindInStoreContainerInline();
			}
		});

		$document.on('click', '.product-content-form-find-in-store-close', function(event){
			event.preventDefault();
			$findInStoreContainer.addClass('hide');
			findInStoreUtil.closeFindInStoreContainer($('.find-in-store-container.in-line'));
		});

		$searchForm.on('submit', function(event){
			event.preventDefault();
			_submitForm(event);
		});
		$searchInput.on('click', _zipCodeClick);
		$useMyLocationButton.on('click', _useMyLocationClick);
	}

	function _submitForm(event){
		if(!$searchInput.val()){
            $searchInput.trigger('focus');
				return;
		}
		event.preventDefault();
		findInStoreUtil.clearRetailStoreForm();
		document.activeElement.blur();
		if(!$searchInput.val() && !$('.zip-input-wrapper .valid').length && !WCS_CONFIG.PDP.pdpInstoreAutoCompleteEnabled){
            $searchInput.addClass('error');
			$('.zipcode-error-msg').removeClass('hide');
		}
		findInStoreModel.resetOMSFindInStoreError();
		if(!$searchInput.hasClass('error') && $searchInput.val()){

			var enteredPostalCodeValue = $('.find-a-store-form-js form input[name="shipToStoreZip"]').val();
			if(enteredPostalCodeValue){
				findInStoreUtil.setEnteredZipToCookie(enteredPostalCodeValue);
			}
			findInStoreModel
				.getStoreData(false, true)
				.done(function(data) {
					findInStoreRender.renderData(data, 'zip-location');
					$('.reveal-overlay:visible').animate({scrollTop: $('.store-results-list').offset().top});
				});
		}
	}

	function shouldOpenPopUp() {
		var isFindStoreButtonEnabled = !$findStoreButton.hasClass('disabled');

		return isFindStoreButtonEnabled && (isROBISEnabled || isPopupEnabled);
	}

	function _zipCodeClick(event){

		if(WCS_CONFIG.get("BOPIS::bopisEnabled")) {
			var enteredPostalCodeValue = $('.find-a-store-form-js form input[name="shipToStoreZip"]').val();
			if(enteredPostalCodeValue){
				findInStoreUtil.setEnteredZipToCookie(enteredPostalCodeValue);
			}
		}
		if($('.zipcode-error-msg').length){
            $searchInput.removeClass('error');
			$('.zipcode-error-msg').addClass('hide');
		}
	}

	function _useMyLocationClick(event){
		event.preventDefault();
		_useMyLocation();
	}

	function _useMyLocation() {
        $('.ship-to-store-radius-js').val($('.ship-to-store-radius-js option:last').val());
		findInStoreUtil.clearRetailStoreForm();
		findInStoreModel
			.getStoreData(true, false)
			.done(function(data){
				findInStoreRender.renderData(data, 'user-location');
			});
	}

	function isOutOfStock() {
		return $addToCartButton.hasClass('btn-out-of-stock');
	}

	function enableFindInStore() {
		$findStoreButton
			.removeClass('disabled')
			.prop('disabled', false);
		$('.find-in-store-container.in-line').removeClass('hide');
	}

	function disableFindInStore() {
		if (!isROBISEnabled) {
			$findStoreButton
				.addClass('disabled')
				.prop('disabled', true);
			$('.find-in-store-container.in-line').addClass('hide');
		}
	}

	function renderFindInStoreAltDisplay() {
		if(isOutOfStock()) {
			// If product is OOS
			disableFindInStore();
		} else if (!isOneSizeProduct && !isPreSelectedProduct){
			disableFindInStore();
		} else {
			enableFindInStore();
		}

		if (isOneSizeProduct || isPreSelectedProduct) {
			isAllAttributeSelected = true;
		}

		isPopupEnabled = isAllAttributeSelected;
	}

	function findInStoreAltDisplayHandlers () {
		if( context.findInStoreEventHandlers === true) {
			return;
		}
		$.pubsub('subscribe', 'WCS.PRODUCTFORM.PRESELECTED_VALUES.INIT',  function(event, data) {
			isPreSelectedProduct = data;
		});

		$.pubsub('subscribe', 'WCS.PRODUCTFORM.ATTRIBUTE.CHANGE.COMPLETE', function(event, data) {
			if(data.originateFromClick) {
				// If product is out of stock or size is not selected, disable find-in-store-button
				var isSizeSelected = $('.attr-size .attr-box.selected').length > 0;
				if(isOutOfStock() || !isSizeSelected) {
					disableFindInStore();
				} else {
					enableFindInStore();
				}

				if (isOneSizeProduct || data) {
					isAllAttributeSelected = true;
				}

				isPopupEnabled = isAllAttributeSelected;
			}
		});

		$.pubsub('subscribe','window.resize.breakpoint',function(event, data) {
			renderFindInStoreAltDisplay();
		});

		$.pubsub('subscribe','WCS.PRODUCTFORM.CURRENT_SELECTION.NOT_ALL_SELECTED', function() {
			isAllAttributeSelected = false;
		});

		$.pubsub('subscribe','WCS.PRODUCTFORM.CURRENT_SELECTION.ALL_SELECTED.NOT_EXIST', function() {
			isAllAttributeSelected = false;
		});

		$.pubsub('subscribe','WCS.PRODUCTFORM.CURRENT_SELECTION.ALL_SELECTED.EXIST', function() {
			isAllAttributeSelected = true;
		});

		context.findInStoreEventHandlers = true;
	}

	function initROBIS() {
		if( !context.robisEventInitialized) {
			$.pubsub('subscribe', 'WCS.PRODUCTFORM.ATTRIBUTE.CHANGE.COMPLETE', enableFindInStore);
			$.pubsub('subscribe', 'WCS.PRODUCTFORM.SELECTION.UPDATED', enableFindInStore);
			$.pubsub('subscribe', 'WCS.PRODUCTFORM.COLOR.ITEM.AVAILABILITY', enableFindInStore);
			$.pubsub('subscribe', 'WCS.PRODUCTFORM.COLORWAY_PRODUCT.NEW', enableFindInStore);
			context.robisEventInitialized = true;
		}


		$findInStoreContainer.on('click', '.size-value-js', function () {
			var isActive = $findInStoreContainer
				.find('.size-value-js')
				.hasClass('open');
			findInStoreUtil.setSelectSizeView(!isActive);
		});

		$findInStoreContainer.on('click', '.select-size-button-js', function () {
			if (findInStoreUtil.getIsSplitSizedEnabled()) {
				findInStoreUtil.handleSplitSizeSelected($(this));
			} else {
				var previousSize = findInStoreUtil.getSelectedSize();
				var $this = $(this);
				var newSize = $this.data('attribute-value');
	
				if (previousSize === null) {
					findInStoreUtil.setSizeSelectedView();
				}
	
				findInStoreUtil.updateActiveSize(newSize, $this.attr('data-catentry-id'));
				findInStoreUtil.setSelectSizeView(false);
			}


			if (!$('.store-results-list-js').is(':empty')) {
				if ($searchInput.val()) {
					$searchStoresButton.trigger('click');
				} else {
					$useMyLocationButton.trigger('click');
				}
			}
		});

		$findInStoreContainer.on('click', '.robis-reserve-button-js', function () {
			var $this = $(this);
			$this.addClass('hide');
			findInStoreUtil.clearROBISErrorMessage();

			findInStoreModel.createOrder($this.data())
				.then(function() {
					var $reserveForm = findInStoreUtil.getROBISReserveForm();
					$this
						.parents('.store-details-js')
						.after($reserveForm);

					pluginLoader.runVFDPPlugins();
					formValidate.validation();

					findInStoreUtil.scrollToROBISForm();
				})
				.catch(function (error) {
					if (error.message) {
						$this
							.closest('.row')
							.before(findInStoreUtil.createROBISErrorMessage(error.message));
					}
					$this.removeClass('hide');
				});
		});

		$findInStoreContainer.on('click', '.robis-reserve-form-submit-button', function () {
			var $this = $(this);
			var $form = $this.parents('form');
			findInStoreUtil.clearROBISErrorMessage();

			$form.validate();

			if ($form.valid() && !$this.hasClass('disabled')) {
				$this.addClass('disabled');

				var data = ['firstName', 'lastName', 'email', 'phone', 'comments']
					.reduce(function (acc, field) {
						var value = $form.find('[name="'+ field +'"]').val();

						if (value) {
							acc[field] = value;
						}

						return acc;
					}, {});

				findInStoreModel.processOrder(data)
					.then(function(response) {
						findInStoreUtil.setRobisFinishedView(response);
					})
					.catch(function (error) {
						if (error.message) {
							$this
								.closest('.row')
								.before(findInStoreUtil.createROBISErrorMessage(error.message));
						}
					})
					.then(function () {
						$this.removeClass('disabled');
					});
			}
		});

		$findInStoreModal.on('click', '.continue-shopping-button-js', function () {
			$findInStoreModal.find('.close-button').trigger('click');
		});

		enableFindInStore();
	}
});
